import React, { useEffect } from "react";
import withIntl from "../utils/withIntl";
import Typography from "@material-ui/core/Typography";
import AyceForm from "../components/Arrangements/AyceForm";
import Grid from "@material-ui/core/Grid";
import ArrangementsList from "../components/Arrangements/ArrangementsList";
import Button from "@material-ui/core/Button";
import { useParams } from "react-router-dom";
import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import { updateSpMerchant } from "../store/SpMerchantApi";

function Arrangements(props) {
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const spMerchant = cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);
  const [activatedAyce, setActivatedAyce] = React.useState(!!spMerchant.sp_ayce_setting);
  const [arrangements, setArrangements] = React.useState(
    spMerchant.sp_ayce_setting ? spMerchant.sp_ayce_setting.sp_ayce_article_flags : null
  );

  const onChangeSpMerchant = () => {
    if (cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId).sp_ayce_setting != null) {
      setArrangements([
        ...cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId).sp_ayce_setting
          .sp_ayce_article_flags,
      ]);
    } else {
      setArrangements(null);
      setActivatedAyce(false);
    }
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.SP_MERCHANT_UPDATED, onChangeSpMerchant);
  }, []);

  return (
    <div>
      <Typography gutterBottom variant="h5">
        {props.intl.formatMessage({ id: "arrangements" })}
      </Typography>

      <Button
        onClick={() => {
          if (activatedAyce) {
            if (window.confirm(props.intl.formatMessage({ id: "settings_will_be_deleted" }))) {
              {
                let newData = { sp_ayce_setting: null };
                updateSpMerchant(spMerchant, newData, []);
              }
            }
          } else {
            setActivatedAyce(true);
          }
        }}
      >
        {spMerchant.sp_ayce_setting
          ? props.intl.formatMessage({ id: "de-activate_all_you_can_eat" })
          : props.intl.formatMessage({ id: "all_you_can_eat_setup" })}
      </Button>
      {activatedAyce && (
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <AyceForm />
          </Grid>
          {spMerchant.sp_ayce_setting && (
            <Grid item xs={12} md={6}>
              <ArrangementsList arrangements={arrangements} spMerchantId={spMerchantId} spMerchant={spMerchant} />
            </Grid>
          )}
        </Grid>
      )}
    </div>
  );
}

export default withIntl(Arrangements);
